import { Component, ComponentRef, ViewChild, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, Output, Input } from '@angular/core';
import { CustomerTemplate, StateMiscArgument, CustomerConfig } from '../../../shared/models/customer-config';
import { ComponentsManagerService } from 'nm-socle-application/app/shared/services/component-manager.service';
import { FormComponentI } from 'nm-socle-application/app/shared/interfaces/form-component-i.interface';
import { InternalStateEvent } from 'nm-socle-application/app/shared/models/internal-state-event';
import { LoaderDirective } from 'nm-socle-application/app/shared/directives/loader-directive';
import { TemplateInitService } from 'nm-socle-application/app/shared/services/template-init.service';
import {CustomerStyle} from 'nm-socle-application/app/shared/models/customer-style';
import {AbstractComponent} from 'nm-socle-application/app/shared/models/abstract-component';

@Component({
    selector: 'template-state-container',
    templateUrl: './template-state-container.component.html',
    styleUrls: ['./template-state-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class TemplateStateContainerComponent extends AbstractComponent implements FormComponentI {
    public templateType:string = CustomerTemplate.TEMPLATE_HOME_PAGE;
    public customStyles:any = {};

    private _customerConfig:CustomerConfig;

    @ViewChild(LoaderDirective) public loaderHost: LoaderDirective;
    protected _compoRef:ComponentRef<Component>;

    @Output() public closeEvent: EventEmitter<any> = new EventEmitter();
    @Output() public internalStateEvent: EventEmitter<InternalStateEvent> = new EventEmitter();
    @Input() public misc:StateMiscArgument[] = [];

    constructor(
        protected _cd:ChangeDetectorRef,
        protected _templateInitService: TemplateInitService,
        protected _componentsManagerService: ComponentsManagerService,
    ) {
        super(_cd);

        this.closeEvent = new EventEmitter();
    }

    public ngOnInit() {
        super.ngOnInit();


        //type MONO/DUO
        this.addSub = this._templateInitService.templateType$.subscribe(type => {
            this.templateType = type;

            this._initTemplate();
        });

        // Customer configuration
        this.addSub = this._templateInitService.customerConfig$.subscribe(custConf => {
            this._customerConfig = custConf;

            this._parseTemplateStyles(this._customerConfig.styles);
        });

        this.markForCheck();
    }

    protected _initTemplate() {
        this._compoRef = this._componentsManagerService.createComponent(this._compoRef, this.templateType, this.loaderHost);

        if(this._compoRef != undefined) {
            this._compoRef.changeDetectorRef.detectChanges();

            if(this._compoRef.instance['closeEvent'] != undefined) {
                this.addSub = this._compoRef.instance['closeEvent'].subscribe(evt => {
                    this.closeEvent.emit(evt);
                });
            }
        } else {
            console.error('Template type "'+this.templateType+'" not found');
        }

        this.markForCheck();
    }

    private _parseTemplateStyles(style:any) {
        this.customStyles = this._templateInitService.parseCustomerStyle(style, CustomerStyle.positionsMargins);

        this.markForCheck();
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/templates/template-state-container/template-state-container.component.ts